module.exports = __webpack_public_path__ + "img/video-report.51d46d0.png";